<ion-app>
    <div class="offline-container" [class.offline-container-active]="!(isOnline$ | async)">
        <div>
            <ion-icon name="alert-circle-outline" class="offline-icon"></ion-icon>
            <p>You are currently offline. This may cause some issues tracking your ride. We'll do our best to keep track of your ride, but be aware that some data may be lost.</p>
        </div>
    </div>
    <ion-router-outlet></ion-router-outlet>
</ion-app>
